var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveBooksStreamlineUltimate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.5.75h7s1.5 0 1.5 1.5v19.5s0 1.5-1.5 1.5h-7s-1.5 0-1.5-1.5V2.25S2 .75 3.5.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5 18.25a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm.75-14h2.5s.5 0 .5.5v8s0 .5-.5.5h-2.5s-.5 0-.5-.5v-8s0-.5.5-.5ZM13.5.75h7s1.5 0 1.5 1.5v19.5s0 1.5-1.5 1.5h-7s-1.5 0-1.5-1.5V2.25s0-1.5 1.5-1.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15 18.25a2 2 0 1 0 4 0 2 2 0 0 0-4 0Zm.75-14h2.5s.5 0 .5.5v8s0 .5-.5.5h-2.5s-.5 0-.5-.5v-8s0-.5.5-.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveBooksStreamlineUltimate);
export default __webpack_public_path__ + "static/media/Archive-Books--Streamline-Ultimate.d2eeb4ee556ea218286f5e4f0a885beb.svg";
export { ForwardRef as ReactComponent };